<script setup lang="ts">
import ChatText from './ChatText.vue';
import UserName from './UserName.vue';
import { useChatStore, useChatStoreWithWatch } from '../stores/chatStore';
import IntentSuggestions from './IntentSuggestions.vue';
import SessionDivider from './SessionDivider.vue';


const chatStore = useChatStore();
const chatStoreWithWatch = useChatStoreWithWatch();
const config = useRuntimeConfig();
</script>

<template>
  <div class="messageContainer flex-1 overflow-y-auto flex flex-col gap-8 py-7">
    <template v-for="(message, index) in chatStore.messages">
      <div>
        <SessionDivider v-if="message.type === 'session_divider'" />
        <template v-else>
          <UserName
            v-if="index === 0 || chatStore.messages[index - 1]?.type === 'session_divider' || message.author !== chatStore.messages[index - 1]?.author"
            :author="message.author" />
          <ChatText v-if="message.type !== 'intent_suggestions'" :text="message.text" direction="left"
            :user="message.author == 'me' ? '自分' : config.public.botName" :answer="message.answer" :type="message.type"
            :scenarios="message.scenarios" :pages="message.pages" :historyId="message.historyId"
            :isGoodReviewed="message.isGoodReviewed" :isBadReviewed="message.isBadReviewed" :copyText="message.copyText"
            :language="message.language" :reviewPattern="message.reviewPattern" :keywordUrl="message.keywordUrl"
            :keywordStr="message.keywordStr" :questions="message.questions" :imageUrl="message.imageUrl"
            :isFollowUp="message.isFollowUp ?? false" :followUpTaskId="message.followUpTaskId"
            :IsDspUser="index === 0 || chatStore.messages[index - 1]?.type === 'session_divider' || message.author !== chatStore.messages[index - 1]?.author" />
          <div v-if="message.type !== 'intent_suggestions'"
            :class="chatStore.windowExtend ? 'px-4' : 'px-[2.9rem]'">
            <RelatedQuestions
              :isShow="message.answer && message.type === 'text'"
              :questions="message.relatedQuestions ?? []"
              :language="message.relatedQuestionsLang || message.language" />
          </div>
          <IntentSuggestions v-else :suggestions="message.intentSuggestions?.suggestions || []"
            :reason="message.intentSuggestions?.reason || message.intentReason || ''" :language="message.language" />
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped>
::-webkit-scrollbar {
  /* スクロールバー全体の幅 */
  width: 13px;

  /* スクロールバーの背景色 */
  background-color: none
}

::-webkit-scrollbar-thumb {
  /* スクロールバーの丸み */
  border-radius: 10px;

  /* スクロールバーの色 */
  box-shadow: inset 0 0 10px 10px #C3C3C3;

  /* スクロールバーの左右の余白 */
  border: solid 4px transparent;
}
</style>
